<div id="page-wrapper" appUserActive (calltMethod)="authenticator.authStatus === 'authenticated' ? userActive() : null">
    <ngx-spinner bdColor="rgb(0,0,0, 0.2)" size="large" color="#89e8ff" type="line-spin-clockwise-fade"
        [fullScreen]="true">
        <p style="color: white"> Cargando... </p>
    </ngx-spinner>

    <!-- Layout público -->
    <!--<ng-container *ngIf="!isPrivateRoute">
        <router-outlet></router-outlet>
    </ng-container>-->

    <!-- Layout privado -->
    <!--<ng-container *ngIf="isPrivateRoute">-->
        <ng-container *ngIf="authenticator.authStatus === 'authenticated'; else elseLogin">
            <div id="page-container">
                <mat-sidenav-container class="example-container" id="mat-sidenav-container">
                    <mat-sidenav #sidenav mode="side" [(opened)]="opened" id="mat-sidenav-principal">
                        <app-mat-side-menu></app-mat-side-menu>
                    </mat-sidenav>

                    <mat-sidenav-content>
                        <div id="main-container" [ngClass]="{'d-none': !showContent}">
                            <header class="navbar navbar-default justify-content-start ml-2" style="background-color: var(--main-bg);">
                                <ul class="nav navbar-nav-custom" style="width: 100%;">
                                    <li>
                                        <div class="menuToggle" (click)="sidenav.toggle()">
                                            <a href="javascript:void(0)" style="color: #000">
                                                <i class="fa fa-bars fa-fw"></i>
                                            </a>
                                        </div>
                                    </li>
                                    <li>
                                        <img src="assets/img/logo_informax_h.png" alt="" width="150px" style="cursor: pointer;" [routerLink]="['']">
                                    </li>
                                    <li class="mt-4 ml-auto mr-5" style="color: grey;">
                                        <span>{{ruta}}</span> <span id="span-menutoggle"></span>
                                    </li>
                                </ul>
                            </header>

                            <div id="page-content" style="background-color: var(--main-bg);">
                                <router-outlet></router-outlet>
                            </div>

                            <footer class="clearfix">
                                <div class="pull-right">
                                    Hecho con <i class="fa fa-heart text-danger"></i> por 
                                    <a href="https://www.informax.cl" target="_blank">Informax</a>
                                </div>
                                <div class="pull-left">
                                    Informax &copy; 2021 - version 0.9.02
                                </div>
                            </footer>
                        </div>
                    </mat-sidenav-content>
                </mat-sidenav-container>
            </div>
        </ng-container>

        <ng-template #elseLogin>
            <app-login></app-login>
        </ng-template>
    <!--</ng-container>-->
</div>

<a href="#" id="to-top"><i class="fa fa-angle-double-up"></i></a>

<script src="assets/js/pages/index.js"></script>
<script>$(function () { Index.init(); });</script>
